<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
  >
    <div class="fs-14 color-33 bold">
      导航栏设置
    </div>

    <div class="flex m-t-20">
      <div class="color-33 fs-14 m-r-10 flex a-center">标题名称:</div>
      <Input style="width: 200px" v-model:value="iteminfo.config.title"/>
    </div>

    <div class="flex m-t-20">
      <div class="color-33 fs-14  m-r-10 flex a-center">标题颜色:</div>
      <div class="border w-100 b-radius-3 flex a-center p-h-10" style="height: 32px">
        {{ iteminfo.config.titleColor }}
      </div>
      <ColorPicker class="m-l-10 ld-color-pick" recommend
                   v-model="iteminfo.config.titleColor"/>
    </div>

    <div class="flex m-t-20">
      <div class="color-33 fs-14  m-r-10 flex a-center">背景颜色:</div>
      <div class="border w-100 b-radius-3 flex a-center p-h-10" style="height: 32px">
        {{ iteminfo.config.bgColor }}
      </div>
      <ColorPicker class="m-l-10 ld-color-pick" recommend
                   v-model="iteminfo.config.bgColor"/>
    </div>

    <div class="fs-14 color-33 m-t-30 bold">
      金刚区设置
    </div>
    <div class="w-full m-t-20">
      <span>模块显示：</span>
      <RadioGroup v-model="iteminfo.config.part1Show">
        <Radio :label="1" style="margin-right: 20px">显示</Radio>
        <Radio :label="2">隐藏</Radio>
      </RadioGroup>
    </div>

    <div class="flex m-t-20">
      <div class="color-33 fs-14 m-r-10 flex a-center">模块标题:</div>
      <Input style="width: 200px" v-model:value="iteminfo.config.part1Title"/>
    </div>
    <div class="fs-14 color-33 m-t-30 bold">
      列表设置
    </div>
    <div class="w-full m-t-20">
      <span>模块显示：</span>
      <RadioGroup v-model="iteminfo.config.part2Show">
        <Radio :label="1" style="margin-right: 20px">显示</Radio>
        <Radio :label="2">隐藏</Radio>
      </RadioGroup>
    </div>
    <div class="fs-14 color-33 m-t-30 bold">
      退出设置
    </div>
    <div class="w-full m-t-20">
      <span>模块显示：</span>
      <RadioGroup v-model="iteminfo.config.part3Show">
        <Radio :label="1" style="margin-right: 20px">显示</Radio>
        <Radio :label="2">隐藏</Radio>
      </RadioGroup>
    </div>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import UpLoadImage from '../../common/UpLoadImage'
import RatioDiv from '@/components/common/RatioDiv'
import HotZone from '@/components/common/zone/Hotzone'

export default {
  name: 'MineSettingWidget',
  components: {
    HotZone,
    RatioDiv,
    BaseSettingWidget,
    UpLoadImage,
  },
  props: {
    iteminfo: Object
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    uploadcoversuccess (data) {
      if (data && data.length) {
        this.iteminfo.coverImgUrl = data[0].url
      }
    },
    onDelClick (index) {
      this.iteminfo.dataList.splice(index, 1)
    },
    getUpColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor (index, length) {
      if (length === 0 || index === length - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    delImg () {
      this.iteminfo.dataList = []
      this.iteminfo.coverImgUrl = ''
    },
    handleAdd (zone) {
      zone.url = ''
      console.log(zone)
      this.iteminfo.dataList.push(zone)
    },
    handleRemove (index) {
      this.iteminfo.dataList.splice(index, 1)
    },
    handleChange () {

    },
  }
}
</script>

<style lang="scss" scoped>
</style>
